import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import Dashboard from './Dashboard';
import PickUpPointDashboard from './PickUpPointDashboard';

const TABS = [
  { key: 'overall', label: 'Overall' },
  { key: 'pick-up-points', label: 'Pick-up points' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

const DashboardPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab: TabKey = searchParams.get('tab') === 'pick-up-points' ? 'pick-up-points' : 'overall';

  const handleTabChange = (tab: TabKey) => {
    setSearchParams((prev) => {
      if (tab === 'overall') prev.delete('tab');
      else prev.set('tab', tab);
      return prev;
    });
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="px-4 md:px-6 pt-4 border-b border-gray-200">
        <nav className="-mb-px flex space-x-6" aria-label="Dashboard views">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => handleTabChange(tab.key)}
              aria-current={activeTab === tab.key ? 'page' : undefined}
              className={`whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium ${
                activeTab === tab.key
                  ? 'border-black text-gray-900'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'pick-up-points' ? <PickUpPointDashboard /> : <Dashboard />}
    </div>
  );
};

export const PickUpPointDashboardRedirect = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('tab', 'pick-up-points');
  return <Navigate to={`/dashboard?${params.toString()}`} replace />;
};

export default DashboardPage;
